import { render, staticRenderFns } from "./targetStatistics.vue?vue&type=template&id=9c195410&scoped=true&"
import script from "./targetStatistics.vue?vue&type=script&lang=js&"
export * from "./targetStatistics.vue?vue&type=script&lang=js&"
import style0 from "./targetStatistics.vue?vue&type=style&index=0&id=9c195410&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c195410",
  null
  
)

export default component.exports